export default __webpack_public_path__ + "static/media/Convit-Z-200-ml-eng.41519f93.jpg";